import React from "react";
import {Button, Empty, Tooltip} from "antd";
import {EyeOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ResponsiveDataTable} from "components/_defaultComponents/ResponsiveDataTable";
import {Shortener} from "components/_defaultComponents/Shortener/Shortener";
import {APPLICATION_TYPES} from "constants/application";
import {ApplicationStatusTag} from "../common/ApplicationStatusTag";
import {formatDate, getCityDistrictLabel, getDetailRoute} from "../common/applicationUtils";

export const PreviousApplicationsTable = ({type, rows}) => {
    const {t} = useTranslation(["applications"]);
    const label = key => t(`detail.previous.columns.${key}`, {ns: "applications"});
    const cell = key => () => ({"data-label": label(key)});
    const isCompany = type === APPLICATION_TYPES.company;

    const column = (key, render) => ({title: label(key), key, render, onCell: cell(key)});

    const columns = [
        column("detail", (_, record) => (
            <Link to={getDetailRoute(type, record._id)} target="_blank" rel="noopener noreferrer">
                <Button type="link" size="small" icon={<EyeOutlined />} />
            </Link>
        )),
        column("date", (_, record) => formatDate(record.createdAt)),
        column("matched", (_, record) =>
            (record.matchedFields || []).map((field, index) => (
                <React.Fragment key={field}>
                    {index > 0 && ", "}
                    <Tooltip title={record[field] || "-"}>
                        <span>
                            {t(`detail.previous.matchedFields.${field}`, {ns: "applications"})}
                        </span>
                    </Tooltip>
                </React.Fragment>
            ))
        ),
        column("cityDistrict", (_, record) => (
            <div style={{maxWidth: 240}}>
                <Shortener text={getCityDistrictLabel(record, type)} length={48} />
            </div>
        )),
        isCompany
            ? column("companyName", (_, record) => record.companyName)
            : column("agencyOfficer", (_, record) => record.fullName),
        column("status", (_, record) => <ApplicationStatusTag status={record.status} />)
    ];

    if (!rows.length) {
        return <Empty description={t("detail.previous.empty", {ns: "applications"})} />;
    }

    return (
        <ResponsiveDataTable
            size="small"
            columns={columns}
            dataSource={rows}
            rowKey="_id"
            scroll={{x: "max-content"}}
            pagination={false}
        />
    );
};
